import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../includes/Header';
import Footer from '../../includes/Footer';
import { FaFileLines, FaWhatsapp, FaBoxOpen, FaCircleCheck, FaXmark, FaRegCircleCheck, FaArrowRight } from "react-icons/fa6";
import { FaStar, FaStarHalfAlt } from "react-icons/fa";
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import Loader from '../../components/Loader/Loader';
import { getHome, postStoreCart, getCartLogin } from '../../apiservices/ApiServices';
import { ToastContainer, toast } from 'react-toastify';
import ProductCard from '../../components/ProductCard/ProductCard';
import { useCartWishlist } from '../CartWishlistContext';
import useScrollRestoration from '../useScrollRestoration';


const Home = () => {
    const [isLoading, setLoading] = useState(true);
    const [isLoadings, setLoadings] = useState(false);
    const [data, setData] = useState([]);
    const [show, setShow] = useState(false);
    const [testimonial, setTestimonial] = useState([]);
    const [wishlistsTot, setWishlistsTot] = useState(1);
    const { cart, setCart, wishlist, isLogin, setIsLogin, addToCart, toggleWishlist } = useCartWishlist();
    const scrollRef = useRef(null);
    const swiperRef = useRef(null);
    useScrollRestoration(!isLoading);

    const scroll = (direction) => {
        if (scrollRef.current) {
            const scrollAmount = 250;

            scrollRef.current.scrollBy({
                left: direction === "next" ? scrollAmount : -scrollAmount,
                behavior: "smooth",
            });
        }
    };

    const getHomedata = async () => {
        try {
            const res = await getHome();
            setData(res.data.data);
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    };

    const postCartData = async (postdata) => {
        try {
            const res = await postStoreCart(postdata);
        } catch (error) {
            console.log(error);
        }
    };

    const handleCartUpdate = (updatedCart) => {
        const formattedCart = Object.entries(updatedCart).map(([sku_id, quantity]) => ({
            sku_id: parseInt(sku_id, 10),
            quantity
        }));

        localStorage.setItem("cart", JSON.stringify(formattedCart));
        setCart(formattedCart);
    };

    const initializeQuantities = (items) => {
        const initialQuantities = {};
        items.forEach(item => {
            initialQuantities[item.sku_id] = item.cart_quantity || 1;
        });

        handleCartUpdate(initialQuantities);
    };

    const updateLoginCartAPI = async () => {
        try {
            const res = await getCartLogin();
            initializeQuantities(res.data.data);
        } catch (error) {
        }
    };

    useEffect(() => {
        localStorage.removeItem("instockonlys");
        localStorage.removeItem("priceRanges");
        localStorage.removeItem("selectedFilterss");
        localStorage.removeItem("selectedSortBys");

        localStorage.removeItem("instockonly");
        localStorage.removeItem("priceRange");
        localStorage.removeItem("selectedFilters");
        localStorage.removeItem("selectedSortBy");


        if (localStorage.getItem('userToken')) {
            const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
            if (!storedCart?.length) {
                updateLoginCartAPI();
            }
            else {
                postCartData(storedCart);
                updateLoginCartAPI();
            }
        }
        setLoading(true);
        getHomedata();


    }, [])

    useEffect(() => {
        const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
        setCart(storedCart);
    }, []);

    const handleClose = () => {
        setShow(false);
        setTestimonial([]);
    };



    return (
        <>
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />
            <Header CartTot={cart.length} WishTot={wishlistsTot} toast={toast} />
            {isLoading ? <Loader /> :
                <>

                    <section id='slider'>
                        <div className='sliderboxs'>
                            <Swiper
                                ref={swiperRef}
                                modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                                spaceBetween={0}
                                slidesPerView={1}
                                navigation
                                pagination={{ clickable: true }}
                                scrollbar={{ draggable: false }}
                                loop={true}
                                center={true}
                                autoplay={{
                                    delay: 3000,
                                    disableOnInteraction: false,
                                    pauseOnMouseEnter: false,
                                }}
                                onMouseEnter={() => {
                                    swiperRef.current?.autoplay?.start();
                                }}
                                onMouseLeave={() => {
                                    swiperRef.current?.autoplay?.stop();
                                }}
                            >
                                {Array.isArray(data?.top_slider) && (
                                    <>
                                        {data?.top_slider?.map((item, index) => (
                                            <SwiperSlide key={`thumb-${index}`}>
                                                <div className='sliderimgs'>
                                                    <Link to={item?.button_data[0]?.url}>
                                                        <img src={item.image_url} alt={item.alt_tag} title='Slider' />
                                                    </Link>
                                                </div>
                                                {/* <div className="container">
                                                    <div className="row align-items-center">
                                                        <div className="col-lg-5">
                                                            <div className='slider-content'>
                                                                <h1 dangerouslySetInnerHTML={{ __html: item.title }} />
                                                                <div dangerouslySetInnerHTML={{ __html: item.description }} />
                                                                <div className="d-flex flex-wrap gap-2 mt-4">
                                                                    {item?.button_data.map((button) => (
                                                                        <Link className="btn btn-teal" to={button.url}>{button.text}</Link>
                                                                    ))}
                                                                </div>
                                                                <div className="mt-2">
                                                                    <Link to={'/find-your-model'} className="btn btn-outline-light-x">Find Your Model</Link>
                                                                </div>
                                                                <div className="hero-badges">
                                                                    <span className="hb"><FaCircleCheck /> 1-Year Warranty</span>
                                                                    <span className="vsep"></span>
                                                                    <span className="hb"><FaCircleCheck /> 2 Replacements</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-7">
                                                            <div className='sliderrightimg'>
                                                                <img src={item.image_url} alt={item.alt_tag} title='Slider' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> */}
                                            </SwiperSlide>
                                        ))}
                                    </>
                                )}
                            </Swiper>
                        </div>

                    </section>

                    {Array.isArray(data?.popular_category) && (
                        <section id='categorysList'>
                            <div className='container'>
                                <div className='category-wrapper'>
                                    <button
                                        className="scroll-btn prev"
                                        onClick={() => scroll("prev")}
                                    >
                                        ❮
                                    </button>
                                    <div className="categorysLists" ref={scrollRef}>
                                        {data?.popular_category?.map((item) => (
                                            <Link className="catspills" to={`/product/categories/${item?.slug}`}>
                                                <div className='catimages'>
                                                    <img src={item?.image_url} alt='' title='' />
                                                </div>
                                                {item.name}
                                            </Link>
                                        ))}
                                    </div>
                                    <button
                                        className="scroll-btn next"
                                        onClick={() => scroll("next")}
                                    >
                                        ❯
                                    </button>
                                </div>
                            </div>
                        </section>
                    )}

                    {Array.isArray(data?.plans) && (
                        <section id='plans'>
                            <div className='plans-block'>
                                <Container>
                                    <div className="eyebrow mb-1">Phone Tempered Glass</div>
                                    <h2 className="sec-title mb-4">Pick Your <span className="text-teal">Protection</span> Level</h2>
                                    <Row className='g-4'>
                                        {data?.plans?.map((item, index) => (
                                            <Col md={4} key={`plans_${item.id}_ids${index}`}>
                                                <div
                                                    className={
                                                        item.is_popular === 1
                                                            ? "tier tier-mid"
                                                            : item.is_premium === 1
                                                                ? "tier tier-dark"
                                                                : "tier"
                                                    }
                                                >
                                                    {item.is_popular === 1 && (<span className="badge-popular">Most Popular</span>)}
                                                    <div className="tname">{item.name}</div>
                                                    {item.max_amount == 'onwards' ?
                                                        <div className="price">
                                                            &#8377;{item.min_amount} {item.max_amount}
                                                        </div>
                                                        :
                                                        <div className="price">
                                                            &#8377;{item.min_amount} - &#8377;{item.max_amount}
                                                        </div>
                                                    }
                                                    <div className="tdesc">{item.short_description}</div>

                                                    <div dangerouslySetInnerHTML={{ __html: item.description }} />

                                                    {item.is_popular === 1 ? (
                                                        <Link to={`/find-your-model/${item?.slug}`} className="btn btn-tealss w-100">Shop Mid Range</Link>
                                                    ) : item.is_premium === 1 ? (
                                                        <Link to={`/find-your-model/${item?.slug}`} className="btn btn-gold w-100">Shop Premium Shield</Link>
                                                    ) : (
                                                        <Link to={`/find-your-model/${item?.slug}`} className="btn btn-tier-outline">Shop Essential</Link>
                                                    )}
                                                </div>
                                            </Col>
                                        ))}
                                    </Row>
                                </Container>
                            </div>
                        </section>
                    )}



                    {/* <section className='mb-5'>
                        <Container>
                            <div className="stats-bar">
                                <Row className="g-4">
                                    <Col className='col-6 col-md-3 stat'>
                                        <FaUser />
                                        <div className="num">50K+</div>
                                        <div className="lbl">Happy Customers</div>
                                    </Col>
                                    <Col className='col-6 col-md-3 stat'>
                                        <FaShieldHalved />
                                        <div className="num">1 YR</div>
                                        <div className="lbl">Warranty on Premium</div>
                                    </Col>
                                    <Col className='col-6 col-md-3 stat'>
                                        <FaArrowRotateLeft />
                                        <div className="num">2x</div>
                                        <div className="lbl">Free Replacements</div>
                                    </Col>
                                    <Col className='col-6 col-md-3 stat'>
                                        <FaRegGem />
                                        <div className="num">6X</div>
                                        <div className="lbl">Stronger Glass</div>
                                    </Col>
                                </Row>
                            </div>
                        </Container>
                    </section> */}



                    {Array.isArray(data?.home_category_products) && (
                        <section id='filterListData' className='homepage'>
                            <Container>
                                {data?.home_category_products.map((dataitem) => {
                                    return (
                                        <section key={dataitem.id || dataitem.slug} className="prod-section">
                                            <div className="sec-head">
                                                <h2 className="sec-title">Choose Your <span className="teal">{dataitem.name}</span></h2>
                                                <Link to={`/product/categories/${dataitem.slug}`} className="cat-link">View All <FaArrowRight /></Link>
                                            </div>
                                            {dataitem?.type == 'category' && (
                                                <div className='categories-box'>
                                                    <Row>
                                                        {dataitem?.items?.map((item, ind) => (
                                                            <Col md={3} key={`cat_${item?.id}_${ind}`}>
                                                                <div className='pcard'>
                                                                    <Link to={`/product/categories/${item.slug}`}>
                                                                        <div className='productImg'>
                                                                            <img src={item?.image_url} alt={item?.name} title={item?.name} />
                                                                        </div>
                                                                        <div className="categorycard-content">
                                                                            <p>{item?.name}</p>
                                                                        </div>
                                                                    </Link>
                                                                </div>
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                </div>
                                            )}

                                            {dataitem?.type == 'product' && (
                                                <div className='relatedproducts-box'>
                                                    <Swiper
                                                        modules={[Navigation, Pagination, Scrollbar, A11y]}
                                                        spaceBetween={0}
                                                        slidesPerView={5}
                                                        navigation
                                                        pagination={{ clickable: true }}
                                                        scrollbar={{ draggable: true }}
                                                        breakpoints={{
                                                            1200: { slidesPerView: 5 },
                                                            1024: { slidesPerView: 4 },
                                                            768: { slidesPerView: 3 },
                                                            640: { slidesPerView: 2 },
                                                            401: { slidesPerView: 2 },
                                                            300: { slidesPerView: 2 },
                                                        }}
                                                    >
                                                        {dataitem?.items?.map((item, ind) => (
                                                            <SwiperSlide key={`prod_${item?.product_id}_${ind}`}>
                                                                <ProductCard
                                                                    PlanName={item?.eligible_plan_name}
                                                                    PlanContent={item?.thumbnail_description}
                                                                    Name={item.name}
                                                                    SkuID={item.sku_id}
                                                                    ImgUrl={item?.media_list[0]?.media_url}
                                                                    Offer={item.discount_per}
                                                                    Price={item.price}
                                                                    OldPrice={item.actual_price}
                                                                    ProductSlug={item.slug}
                                                                    ProductLabel={item?.product_label}
                                                                    Quantitys={item.quantity}
                                                                    Brands={item?.brands?.name}
                                                                    Model={item?.model?.name}
                                                                    Cart={cart}
                                                                    Wishlist={wishlist}
                                                                    ToggleWishlist={toggleWishlist}
                                                                    addToCart={addToCart}
                                                                />
                                                            </SwiperSlide>
                                                        ))}
                                                    </Swiper>
                                                </div>
                                            )}
                                        </section>
                                    );
                                })}
                            </Container>
                        </section>
                    )}

                    {Array.isArray(data?.feature_products) && (
                        <section id='featureProducts'>
                            <Container className='pb-5'>
                                <div className="d-flex justify-content-between align-items-end mb-4 flex-wrap gap-2">
                                    <div>
                                        <div className="eyebrow mb-1">PREMIUM SHIELD</div>
                                        <h2 className="sec-title mb-0">Find Your <span className="text-teal">365 days warranty</span></h2>
                                    </div>
                                    <Link to={'/product/plan/premium-shield'} className="cat-link">View All <FaArrowRight /></Link>
                                </div>

                                <div className='relatedproducts-box'>
                                    <Swiper
                                        modules={[Navigation, Pagination, Scrollbar, A11y]}
                                        spaceBetween={0}
                                        slidesPerView={5}
                                        navigation
                                        pagination={{ clickable: true }}
                                        scrollbar={{ draggable: true }}
                                        breakpoints={{
                                            1200: { slidesPerView: 5 },
                                            1024: { slidesPerView: 4 },
                                            768: { slidesPerView: 3 },
                                            640: { slidesPerView: 2 },
                                            401: { slidesPerView: 2 },
                                            300: { slidesPerView: 2 },
                                        }}
                                    >
                                        {data?.feature_products?.map((item, ind) => (
                                            <SwiperSlide key={`prod_${item?.product_id}_${ind}`}>
                                                <ProductCard
                                                    PlanName={item?.eligible_plan_name}
                                                    PlanContent={item?.thumbnail_description}
                                                    Name={item.name}
                                                    SkuID={item.sku_id}
                                                    ImgUrl={item?.media_list[0]?.media_url}
                                                    Offer={item.discount_per}
                                                    Price={item.price}
                                                    OldPrice={item.actual_price}
                                                    ProductSlug={item.slug}
                                                    ProductLabel={item?.product_label}
                                                    Quantitys={item.quantity}
                                                    Brands={item?.brands?.name}
                                                    Model={item?.model?.name}
                                                    Cart={cart}
                                                    Wishlist={wishlist}
                                                    ToggleWishlist={toggleWishlist}
                                                    addToCart={addToCart}
                                                />
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                </div>
                            </Container>
                        </section>
                    )}

                    <section className="care">
                        <Container>
                            <Row className="align-items-center g-5">
                                <Col className="col-lg-5">
                                    <div className="eyebrow mb-2" style={{ color: '#04393a' }}>Premium Care Promise</div>
                                    <h2>Break It.<br />We Replace It.<br />Twice.</h2>
                                    <p className="cp">Our Premium Shield comes with 2 free replacements — no questions asked. Just claim online in 3
                                        simple steps.</p>
                                    <Link to={'/product/plan/premium-shield'} className="btn btn-gold mt-2">Shop Premium Shield &rarr;</Link>
                                </Col>
                                <Col className="col-lg-7">
                                    <Row className="g-3">
                                        <Col className="col-md-4 position-relative">
                                            <div className="step-card">
                                                <div className="step-num">1</div>
                                                <h5>Register<br />Your Product</h5>
                                                <p>Submit your product details online.</p>
                                                <FaFileLines />
                                            </div>
                                            <span className="step-arrow"></span>
                                        </Col>
                                        <Col className="col-md-4 position-relative">
                                            <div className="step-card">
                                                <div className="step-num">2</div>
                                                <h5>Raise<br />a Claim</h5>
                                                <p>Photo of damage via WhatsApp or web.</p>
                                                <FaWhatsapp />
                                            </div>
                                            <span className="step-arrow"></span>
                                        </Col>
                                        <Col className="col-md-4">
                                            <div className="step-card">
                                                <div className="step-num">3</div>
                                                <h5>Get Free<br />Replacement</h5>
                                                <p>Shipped to your door, fast &amp; free.</p>
                                                <FaBoxOpen />
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                    </section>

                    <section id='compares' className="my-3" style={{ paddingBottom: '50px' }}>
                        <Container>
                            <Row className='g-5 align-items-start'>
                                <Col className='col-lg-4'>
                                    <div className="eyebrow mb-1">Why Mobistorm</div>
                                    <h2 className="sec-title">How We <span className="text-teal">Compare</span></h2>
                                </Col>
                                <Col className='col-lg-8'>
                                    <div className="cmp-wrap">
                                        <table className="cmp">
                                            <thead>
                                                <tr>
                                                    <th>Feature</th>
                                                    <th className="hl">Mobistorm Premium</th>
                                                    <th>Other Brands</th>
                                                    <th>Local Shops</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>6X Stronger Glass</td>
                                                    <td className="hl"><FaCircleCheck /></td>
                                                    <td><FaRegCircleCheck /> <span className="sub">Partial</span></td>
                                                    <td><FaXmark /></td>
                                                </tr>
                                                <tr>
                                                    <td>1-Year Warranty</td>
                                                    <td className="hl"><FaCircleCheck /> <span className="sub">Included</span></td>
                                                    <td><FaRegCircleCheck /> <span className="sub">Paid</span></td>
                                                    <td><FaXmark /></td>
                                                </tr>
                                                <tr>
                                                    <td>2 Free Replacements</td>
                                                    <td className="hl"><FaCircleCheck /> <span className="sub">Yes</span></td>
                                                    <td><FaRegCircleCheck /> <span className="sub">Limited</span></td>
                                                    <td><FaXmark /></td>
                                                </tr>
                                                <tr>
                                                    <td>Privacy Glass 360&deg;</td>
                                                    <td className="hl"><FaCircleCheck /> <span className="sub">Available</span></td>
                                                    <td><FaRegCircleCheck /> <span className="sub">Limited</span></td>
                                                    <td><FaXmark /></td>
                                                </tr>
                                                <tr>
                                                    <td>Camera Lens Rings</td>
                                                    <td className="hl"><FaCircleCheck /> <span className="sub">All Models</span></td>
                                                    <td><FaRegCircleCheck /> <span className="sub">Some Models</span></td>
                                                    <td><FaXmark /></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                </>
            }

            <Footer toast={toast} />

            <Modal id="testi" show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div id='popups' className='reviewsboxs'>
                        <div className='reviewshed'>
                            <div className='userio'>
                                <img src={testimonial.image_url} alt={testimonial.alt_tag} title={testimonial.alt_tag} />
                            </div>
                            <div className='username'>
                                <h4>{testimonial.customer_name}</h4>
                                <p>{testimonial.review_date}</p>
                            </div>
                        </div>
                        <div className="reviewsbody">
                            <div className='rating'>
                                {testimonial.rating == 5 ?
                                    <ul>
                                        <li><FaStar /></li>
                                        <li><FaStar /></li>
                                        <li><FaStar /></li>
                                        <li><FaStar /></li>
                                        <li><FaStar /></li>
                                    </ul> : null
                                }
                                {testimonial.rating == 4.5 ?
                                    <ul>
                                        <li><FaStar /></li>
                                        <li><FaStar /></li>
                                        <li><FaStar /></li>
                                        <li><FaStar /></li>
                                        <li><FaStarHalfAlt /></li>
                                    </ul> : null
                                }
                                {testimonial.rating == 4 ?
                                    <ul>
                                        <li><FaStar /></li>
                                        <li><FaStar /></li>
                                        <li><FaStar /></li>
                                        <li><FaStar /></li>
                                        <li><FaStar style={{ color: '#ccc' }} /></li>
                                    </ul> : null
                                }
                                {testimonial.rating == 3.5 ?
                                    <ul>
                                        <li><FaStar /></li>
                                        <li><FaStar /></li>
                                        <li><FaStar /></li>
                                        <li><FaStarHalfAlt /></li>
                                        <li><FaStar style={{ color: '#ccc' }} /></li>
                                    </ul> : null
                                }
                                {testimonial.rating == 3 ?
                                    <ul>
                                        <li><FaStar /></li>
                                        <li><FaStar /></li>
                                        <li><FaStar /></li>
                                        <li><FaStar style={{ color: '#ccc' }} /></li>
                                        <li><FaStar style={{ color: '#ccc' }} /></li>
                                    </ul> : null
                                }
                                {testimonial.rating == 2.5 ?
                                    <ul>
                                        <li><FaStar /></li>
                                        <li><FaStar /></li>
                                        <li><FaStarHalfAlt /></li>
                                        <li><FaStar style={{ color: '#ccc' }} /></li>
                                        <li><FaStar style={{ color: '#ccc' }} /></li>
                                    </ul> : null
                                }
                                {testimonial.rating == 2 ?
                                    <ul>
                                        <li><FaStar /></li>
                                        <li><FaStar /></li>
                                        <li><FaStar style={{ color: '#ccc' }} /></li>
                                        <li><FaStar style={{ color: '#ccc' }} /></li>
                                        <li><FaStar style={{ color: '#ccc' }} /></li>
                                    </ul> : null
                                }
                                {testimonial.rating == 1.5 ?
                                    <ul>
                                        <li><FaStar /></li>
                                        <li><FaStarHalfAlt /></li>
                                        <li><FaStar style={{ color: '#ccc' }} /></li>
                                        <li><FaStar style={{ color: '#ccc' }} /></li>
                                        <li><FaStar style={{ color: '#ccc' }} /></li>
                                    </ul> : null
                                }
                                {testimonial.rating == 1 ?
                                    <ul>
                                        <li><FaStar /></li>
                                        <li><FaStar style={{ color: '#ccc' }} /></li>
                                        <li><FaStar style={{ color: '#ccc' }} /></li>
                                        <li><FaStar style={{ color: '#ccc' }} /></li>
                                        <li><FaStar style={{ color: '#ccc' }} /></li>
                                    </ul> : null
                                }
                            </div>
                            <div className='procontnts' dangerouslySetInnerHTML={{ __html: testimonial.description }}>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {isLoadings && <Loader />}
        </>
    )
}

export default Home